import { render } from "./page-children.vue?vue&type=template&id=52808d80"
import script from "./page-children.vue?vue&type=script&lang=js"
export * from "./page-children.vue?vue&type=script&lang=js"
script.render = render

export default script